import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  GrnListReq,
  GrnListRes,
  CreateGrnReq,
  ActionGrnRes,
  UpdateGrnReq,
  DeleteGrnReq,
  GrnDetailReq,
  GrnDetailRes,
  LatestGrnReq,
  LatestGrnRes,
  LatestGrnListReq,
  LatestGrnListRes,
  CountReq,
  CountRes,
  GrnImproveListReq,
  GrnImproveListRes,
} from './types'

export const getGrnListAction = createAsyncAction(
  'GRN/GET_GRN_LIST_REQ',
  'GRN/GET_GRN_LIST_SUCCESS',
  'GRN/GET_GRN_LIST_FAILURE',
)<GrnListReq, GrnListRes, Error>()

export const getGrnDetailAction = createAsyncAction(
  'GRN/GET_GRN_DETAIL_REQ',
  'GRN/GET_GRN_DETAIL_SUCCESS',
  'GRN/GET_GRN_DETAIL_FAILURE',
)<GrnDetailReq, GrnDetailRes, Error>()

export const createGrnAction = createAsyncAction(
  'GRN/CREATE_GRN_REQ',
  'GRN/CREATE_GRN_SUCCESS',
  'GRN/CREATE_GRN_FAILURE',
)<CreateGrnReq, ActionGrnRes, Error>()

export const updateGrnAction = createAsyncAction(
  'GRN/UPDATE_GRN_REQ',
  'GRN/UPDATE_GRN_SUCCESS',
  'GRN/UPDATE_GRN_FAILURE',
)<UpdateGrnReq, ActionGrnRes, Error>()

export const deleteGrnAction = createAsyncAction(
  'GRN/DELETE_GRN_REQ',
  'GRN/DELETE_GRN_SUCCESS',
  'GRN/DELETE_GRN_FAILURE',
)<DeleteGrnReq, ActionGrnRes, Error>()

export const getGrnListBySupAction = createAsyncAction(
  'GRN/GET_GRN_LIST_BY_SUP_REQ',
  'GRN/GET_GRN_LIST_BY_SUP_SUCCESS',
  'GRN/GET_GRN_LIST_BY_SUP_FAILURE',
)<GrnListReq, GrnListRes, Error>()

export const getLastesGrnAction = createAsyncAction(
  'GRN/GET_LATEST_GRN_REQ',
  'GRN/GET_LATEST_GRN_SUCCESS',
  'GRN/GET_LATEST_GRN_FAILURE',
)<LatestGrnReq, LatestGrnRes, Error>()

export const getLastesGrnListAction = createAsyncAction(
  'GRN/GET_LATEST_GRN_LIST_REQ',
  'GRN/GET_LATEST_GRN_LIST_SUCCESS',
  'GRN/GET_LATEST_GRN_LIST_FAILURE',
)<LatestGrnListReq, LatestGrnListRes, Error>()

export const getCountAction = createAsyncAction(
  'GRN/GET_COUNT_REQ',
  'GRN/GET_COUNT_SUCCESS',
  'GRN/GET_COUNT_FAILURE',
)<CountReq, CountRes, Error>()

export const getGrnImproveListAction = createAsyncAction(
  'GRN/GET_GRN_LIST_IMPROVE_REQ',
  'GRN/GET_GRN_LIST_IMPROVE_SUCCESS',
  'GRN/GET_GRN_LIST_IMPROVE_FAILURE',
)<GrnImproveListReq, GrnImproveListRes, Error>()

export const clearEventAction = createStandardAction('GRN/CLEAR_EVENT')<void>()
